import { render, staticRenderFns } from "./duoTrainingMobile.vue?vue&type=template&id=186154fc&scoped=true&"
import script from "./duoTrainingMobile.vue?vue&type=script&lang=js&"
export * from "./duoTrainingMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoTrainingMobile.vue?vue&type=style&index=0&id=186154fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186154fc",
  null
  
)

export default component.exports